import * as Color from 'color';

export function contrastColor(
  color: string,
  white: string = '#fff',
  black: string = '#000',
) {
  const L = Color(color).luminosity();
  return L > 0.179 ? black : white;
}
